type FeatureCardsObjectType = {
  [key: string]: {
    imageAltText: string
    title: string
    subTitle: string
    featurePoints: string[]
  }
}

export const featureCardsObject: FeatureCardsObjectType = {
  fantasy: {
    imageAltText: 'Fantasy Feature Card',
    title: 'FANTASY',
    subTitle: 'Personalized Draft Tools & Insights',
    featurePoints: ['Sync Unlimited Leagues', 'Live Draft Assistant', 'Nathan Jahnkes Rankings'],
  },
  mds: {
    imageAltText: 'MDS Feature Card',
    title: 'MOCK DRAFT SIMULATOR',
    subTitle: 'The #1 Mock Draft Sim in the game',
    featurePoints: ['Trade Picks + players', 'Draft grades for every pick', 'Turbo speed with all 7 rounds'],
  },
  draftGuide: {
    imageAltText: 'Draft Guide Feature Card',
    title: 'DRAFT GUIDE + BIG BOARD',
    subTitle: 'Become a draft pro for your team',
    featurePoints: [
      'PFF Grades and advanced data',
      'Positional traits + player comps',
      'Combine + pro day measurables',
    ],
  },
  betting: {
    imageAltText: 'Betting Feature Card',
    title: 'BETTING',
    subTitle: 'Bet smart with data driven betting tools',
    featurePoints: ['Player prop matchups', 'PFF simulation and models', 'Player past performance + trends'],
  },
  pffGrades: {
    imageAltText: 'PFF Grades Feature Card',
    title: 'PFF GRADES + STATS',
    subTitle: 'Advanced data used by the pros',
    featurePoints: ['Used by all 32 NFL Teams', 'NFL + NCAA game + season grades', '400+ data points tracked per play'],
  },
  insights: {
    imageAltText: 'Insights Feature Card',
    title: 'EXPERT ANALYSIS + INSIGHTS',
    subTitle: '200+ Premium Fantasy Articles',
    featurePoints: ['Perfect draft strategy', 'Dynasty, Bestball and IDP', 'Data driven sleepers, fades + winners'],
  },
}
